export class ChatDetailModel {
    constructor(type = 'message', isPatientCreate = false) {
        this.type = type
        this.isPatientCreate = isPatientCreate
    }

    _id?: any
    communication?: any
    communicationId?: any
    isPatientCreate?: boolean
    visitDate?: number
    clientId?: string
    content?: string
    doctorInCharge?: string
    staffInCharge?: string
    tags?: string[]
    note?: string
    images?: string[] = ['init']
    pdfs?: string[] = ['init']
    video?: string[] = ['init']
    next?: string
    type?: string
}



// WEBPACK FOOTER //
// ./src/app/client-app/app-component/chat-detail/chat-detail.model.ts